import styled from 'styled-components';
import { tableCellColor } from '../constants/globalstyles';
import { Table as SemanticTable } from 'semantic-ui-react';



/*
  Child table variants for lighter-weight lists (used for child records / culture action rows)
  - Lighter borders, no box-shadow
  - Slightly smaller font & padding
  - Gentler hover background
  These harmonize visually with the InterventionsTab while remaining usable in PlannerTable and Culture Action lists.
*/
export const ChildTable = styled(SemanticTable) <{ $selectable?: boolean }>`
  && {
    /* match PillarCard borders and shadow for visual consistency */
    border: 1px solid var(--color-gray-200);
    border-radius: 6px;
    box-shadow: var(--shadow-sm);
    background-color: transparent;
    ${props =>
    props.$selectable
      ? `
        &:hover {
          cursor: pointer !important;
        }
      `
      : ''}
  }
`;

export const ChildHeader = styled(SemanticTable.Header)`
  && {
    padding: 0px 8px 2px 8px;
    margin-bottom: 3px;
  }
`;

export const ChildHeaderCell = styled(SemanticTable.HeaderCell) <{ justify?: 'left' | 'right' | 'center' }>`
  && {
    font-family: 'Poppins';
    font-weight: 600;
    font-size: 13px;
    text-align: ${props => props.justify || 'left'} !important;
    color: var(--color-title) !important; /* align header coloring with cards */
    padding: 8px !important;
    border-bottom: 1px solid var(--color-gray-100);
    background-color: var(--color-surface);
  }
`;

export const ChildBody = styled(SemanticTable.Body)``;

export const ChildRow = styled(SemanticTable.Row) <{ $selectable?: boolean }>`
  height: 48px;
  transition: background-color 0.18s ease;
  border-bottom: 1px solid var(--color-gray-100);
  ${props =>
    props.$selectable
      ? `
        &:hover {
          cursor: pointer !important;
        }
        /* highlight cells on hover so the effect shows through even with cell backgrounds */
        &:hover td {
          background-color: #f7fbff !important;
        }
      `
      : ''}
`;

export const ChildCell = styled(SemanticTable.Cell) <{ 
  $firstcol?: boolean;
  justify?: 'left' | 'right' | 'center';
 }>`
  && {
    padding: 8px !important;
    padding-left: ${props => (props.$firstcol ? '12px' : '8px')} !important;
    font-size: ${props => (props.$firstcol ? '12px' : '12px')};
    font-weight: ${props => (props.$firstcol ? 500 : 400)};
    color: ${props => (props.$firstcol ? tableCellColor : tableCellColor)};
    border-bottom: 1px solid var(--color-gray-100);
    background-color: transparent; /* allow row hover highlight to show */
    text-align: ${props => props.justify || 'left'} !important;

  }
`;
